var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "scale-in-center" } }, [
    _c("div", { attrs: { id: "order-service-page" } }, [
      _vm.app_env == "local" || _vm.app_env == "development"
        ? _c("span", { staticClass: "development-label" }, [
            _vm._v("\n            Testovací prostředí\n        "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "close-block" }, [
        _c(
          "a",
          {
            staticClass: "close-block-button",
            on: {
              click: function ($event) {
                return _vm.closeModal()
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor",
                  "aria-hidden": "true",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M6 18L18 6M6 6l12 12",
                  },
                }),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid-container" },
        [
          _c("div", { staticClass: "grid-x grid-padding-x" }, [
            _c(
              "div",
              { staticClass: "large-8 medium-9 small-12 cell centered" },
              [
                _vm.serviceLoadStatus == 2 &&
                this.service.maintenance_slot == true &&
                !this.makeId
                  ? _c("h2", { staticClass: "page-title" }, [
                      _vm._v(_vm._s(_vm.$t("order.titleBinding"))),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.serviceLoadStatus == 2 &&
                (this.service.maintenance_slot == false ||
                  (this.service.maintenance_slot == true && this.makeId))
                  ? _c("h2", { staticClass: "page-title" }, [
                      _vm._v(_vm._s(_vm.$t("order.title"))),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.serviceLoadStatus == 2
                  ? _c("span", { staticClass: "service-title" }, [
                      _vm._v(_vm._s(_vm.serviceName)),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("loader", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.serviceLoadStatus == 0 || _vm.serviceLoadStatus == 1,
                expression: "serviceLoadStatus == 0 || serviceLoadStatus == 1",
              },
            ],
            attrs: { width: 100, height: 100 },
          }),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label" }, [
                            _vm._v(_vm._s(_vm.$t("order.licensePlate"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.license,
                                expression: "license",
                              },
                            ],
                            staticClass: "form-input",
                            attrs: { type: "text", readonly: "" },
                            domProps: { value: _vm.license },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.license = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label required" }, [
                            _vm._v(_vm._s(_vm.$t("order.mileage"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.mileage,
                                expression: "mileage",
                              },
                            ],
                            ref: "mileage",
                            staticClass: "form-input",
                            class: {
                              invalid: !_vm.validations.mileage.is_valid,
                            },
                            attrs: { type: "text", maxlength: "7" },
                            domProps: { value: _vm.mileage },
                            on: {
                              keypress: _vm.validNumber,
                              paste: function ($event) {
                                $event.preventDefault()
                              },
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.mileage = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.mileage.is_valid,
                                  expression: "!validations.mileage.is_valid",
                                },
                              ],
                              staticClass: "validation",
                            },
                            [_vm._v(_vm._s(_vm.validations.mileage.text))]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("h5", { staticClass: "section-title" }, [
                      _vm._v(_vm._s(_vm.$t("order.contactSectionLabel"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label required" }, [
                            _vm._v(_vm._s(_vm.$t("order.firstName"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.firstName,
                                expression: "firstName",
                              },
                            ],
                            ref: "firstName",
                            staticClass: "form-input",
                            class: {
                              invalid: !_vm.validations.firstName.is_valid,
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.firstName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.firstName = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.firstName.is_valid,
                                  expression: "!validations.firstName.is_valid",
                                },
                              ],
                              staticClass: "validation",
                            },
                            [_vm._v(_vm._s(_vm.validations.firstName.text))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label required" }, [
                            _vm._v(_vm._s(_vm.$t("order.lastName"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.lastName,
                                expression: "lastName",
                              },
                            ],
                            ref: "lastName",
                            staticClass: "form-input",
                            class: {
                              invalid: !_vm.validations.lastName.is_valid,
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.lastName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.lastName = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.lastName.is_valid,
                                  expression: "!validations.lastName.is_valid",
                                },
                              ],
                              staticClass: "validation",
                            },
                            [_vm._v(_vm._s(_vm.validations.lastName.text))]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label required" }, [
                            _vm._v(_vm._s(_vm.$t("order.email"))),
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.emailAddress,
                                expression: "emailAddress",
                              },
                            ],
                            ref: "emailAddress",
                            staticClass: "form-input",
                            class: {
                              invalid: !_vm.validations.emailAddress.is_valid,
                            },
                            attrs: { type: "text" },
                            domProps: { value: _vm.emailAddress },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.emailAddress = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.emailAddress.is_valid,
                                  expression:
                                    "!validations.emailAddress.is_valid",
                                },
                              ],
                              staticClass: "validation",
                            },
                            [_vm._v(_vm._s(_vm.validations.emailAddress.text))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("label", { staticClass: "form-label required" }, [
                            _vm._v(_vm._s(_vm.$t("order.phone"))),
                          ]),
                          _vm._v(" "),
                          _c("VuePhoneNumberInput", {
                            attrs: {
                              maxlength: "11",
                              color: "#c8017d",
                              "default-country-code": "CZ",
                              required: "",
                              "only-countries": _vm.phoneNumberOnlyCountries,
                              translations: _vm.phoneNumberTranslations,
                            },
                            on: { update: _vm.onUpdatePhoneNumber },
                            model: {
                              value: _vm.phoneNumber,
                              callback: function ($$v) {
                                _vm.phoneNumber = $$v
                              },
                              expression: "phoneNumber",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.phoneNumber.is_valid,
                                  expression:
                                    "!validations.phoneNumber.is_valid",
                                },
                              ],
                              staticClass: "validation",
                            },
                            [_vm._v(_vm._s(_vm.validations.phoneNumber.text))]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    this.maintenanceIncluded == true
                      ? _c("h5", { staticClass: "section-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("order.servicingActionsSectionLabel"))
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    this.maintenanceIncluded == false
                      ? _c("h5", { staticClass: "section-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("order.servicingActionSectionLabel"))
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    this.maintenanceIncluded == true
                      ? _c("span", { staticClass: "section-description" }, [
                          _vm._v(
                            _vm._s(_vm.$t("order.servicingActionSectionInfo"))
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "section-description",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("order.servicingActionSectionNote")
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.validations.serviceOperations.is_valid,
                            expression:
                              "!validations.serviceOperations.is_valid",
                          },
                        ],
                        staticClass: "validation",
                        staticStyle: { "text-align": "center" },
                      },
                      [_vm._v(_vm._s(_vm.validations.serviceOperations.text))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("ul", { staticClass: "service-operations-list" }, [
                            this.maintenanceIncluded == true
                              ? _c("li", [
                                  _c(
                                    "label",
                                    { attrs: { for: "service-inspection" } },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.serviceOperations,
                                            expression: "serviceOperations",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "service-inspection",
                                          value: "service-inspection",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.serviceOperations
                                          )
                                            ? _vm._i(
                                                _vm.serviceOperations,
                                                "service-inspection"
                                              ) > -1
                                            : _vm.serviceOperations,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.serviceOperations,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = "service-inspection",
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.serviceOperations =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.serviceOperations = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.serviceOperations = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "checkbox-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "order.servicingActionServiceInspectionLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            placement: "right",
                                            arrow: true,
                                          },
                                          expression:
                                            "{ placement : 'right',  arrow: true }",
                                        },
                                      ],
                                      staticClass: "info-icon",
                                      attrs: {
                                        content: _vm.$t(
                                          "order.servicingActionServiceInspectionTooltip"
                                        ),
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "info-icon",
                                        attrs: { src: "/img/info-icon.svg" },
                                      }),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            this.maintenanceIncluded == true
                              ? _c(
                                  "li",
                                  [
                                    _c("label", { attrs: { for: "repair" } }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.serviceOperations,
                                            expression: "serviceOperations",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "repair",
                                          value: "repair",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.serviceOperations
                                          )
                                            ? _vm._i(
                                                _vm.serviceOperations,
                                                "repair"
                                              ) > -1
                                            : _vm.serviceOperations,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.serviceOperations,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = "repair",
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.serviceOperations =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.serviceOperations = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.serviceOperations = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "checkbox-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "order.servicingActionRepairLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              placement: "right",
                                              arrow: true,
                                            },
                                            expression:
                                              "{ placement : 'right',  arrow: true }",
                                          },
                                        ],
                                        staticClass: "info-icon",
                                        attrs: {
                                          content: _vm.$t(
                                            "order.servicingActionRepairTooltip"
                                          ),
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "info-icon",
                                          attrs: { src: "/img/info-icon.svg" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "transition",
                                      { attrs: { name: "fade" } },
                                      [
                                        _vm.serviceOperations.includes("repair")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "container",
                                                attrs: {
                                                  id: "repair-text-container",
                                                },
                                              },
                                              [
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.serviceOperationsRepairText,
                                                      expression:
                                                        "serviceOperationsRepairText",
                                                    },
                                                  ],
                                                  staticClass: "text-input",
                                                  class: {
                                                    invalid:
                                                      !_vm.validations
                                                        .serviceOperationsRepairText
                                                        .is_valid,
                                                  },
                                                  attrs: {
                                                    rows: "2",
                                                    placeholder: _vm.$t(
                                                      "order.servicingActionInputTextPlaceholder"
                                                    ),
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.serviceOperationsRepairText,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.serviceOperationsRepairText =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          !_vm.validations
                                                            .serviceOperationsRepairText
                                                            .is_valid,
                                                        expression:
                                                          "!validations.serviceOperationsRepairText.is_valid",
                                                      },
                                                    ],
                                                    staticClass: "validation",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.validations
                                                          .serviceOperationsRepairText
                                                          .text
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            this.maintenanceIncluded == true
                              ? _c("li", [
                                  _c(
                                    "label",
                                    { attrs: { for: "technical-inspection" } },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.serviceOperations,
                                            expression: "serviceOperations",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "technical-inspection",
                                          value: "technical-inspection",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.serviceOperations
                                          )
                                            ? _vm._i(
                                                _vm.serviceOperations,
                                                "technical-inspection"
                                              ) > -1
                                            : _vm.serviceOperations,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.serviceOperations,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = "technical-inspection",
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.serviceOperations =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.serviceOperations = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.serviceOperations = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "checkbox-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "order.servicingActionTechnicalInspectionLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            placement: "right",
                                            arrow: true,
                                          },
                                          expression:
                                            "{ placement : 'right',  arrow: true }",
                                        },
                                      ],
                                      staticClass: "info-icon",
                                      attrs: {
                                        content: _vm.$t(
                                          "order.servicingActionTechnicalInspectionTooltip"
                                        ),
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "info-icon",
                                        attrs: { src: "/img/info-icon.svg" },
                                      }),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            this.makeId
                              ? _c("li", [
                                  _c(
                                    "label",
                                    { attrs: { for: "calling-action" } },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.serviceOperations,
                                            expression: "serviceOperations",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "calling-action",
                                          value: "calling-action",
                                          onclick: "return false;",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.serviceOperations
                                          )
                                            ? _vm._i(
                                                _vm.serviceOperations,
                                                "calling-action"
                                              ) > -1
                                            : _vm.serviceOperations,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.serviceOperations,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = "calling-action",
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.serviceOperations =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.serviceOperations = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.serviceOperations = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "checkbox-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "order.servicingActionCallingActionLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            placement: "right",
                                            arrow: true,
                                          },
                                          expression:
                                            "{ placement : 'right',  arrow: true }",
                                        },
                                      ],
                                      staticClass: "info-icon",
                                      attrs: {
                                        content: _vm.$t(
                                          "order.servicingActionCallingActionTooltip"
                                        ),
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "info-icon",
                                        attrs: { src: "/img/info-icon.svg" },
                                      }),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "large-6 medium-6 small-12 cell" },
                        [
                          _c("ul", { staticClass: "service-operations-list" }, [
                            this.maintenanceIncluded == true
                              ? _c("li", [
                                  _c(
                                    "label",
                                    { attrs: { for: "service-oil-change" } },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.serviceOperations,
                                            expression: "serviceOperations",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "service-oil-change",
                                          value: "service-oil-change",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.serviceOperations
                                          )
                                            ? _vm._i(
                                                _vm.serviceOperations,
                                                "service-oil-change"
                                              ) > -1
                                            : _vm.serviceOperations,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.serviceOperations,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = "service-oil-change",
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.serviceOperations =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.serviceOperations = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.serviceOperations = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "checkbox-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "order.servicingActionServiceOilChangeLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tippy",
                                          rawName: "v-tippy",
                                          value: {
                                            placement: "right",
                                            arrow: true,
                                          },
                                          expression:
                                            "{ placement : 'right',  arrow: true }",
                                        },
                                      ],
                                      staticClass: "info-icon",
                                      attrs: {
                                        content: _vm.$t(
                                          "order.servicingActionServiceOilChangeTooltip"
                                        ),
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "info-icon",
                                        attrs: { src: "/img/info-icon.svg" },
                                      }),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            this.maintenanceIncluded == true
                              ? _c(
                                  "li",
                                  [
                                    _c(
                                      "label",
                                      { attrs: { for: "breakdown" } },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.serviceOperations,
                                              expression: "serviceOperations",
                                            },
                                          ],
                                          attrs: {
                                            type: "checkbox",
                                            id: "breakdown",
                                            value: "breakdown",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.serviceOperations
                                            )
                                              ? _vm._i(
                                                  _vm.serviceOperations,
                                                  "breakdown"
                                                ) > -1
                                              : _vm.serviceOperations,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a = _vm.serviceOperations,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = "breakdown",
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.serviceOperations =
                                                      $$a.concat([$$v]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.serviceOperations = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.serviceOperations = $$c
                                              }
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "checkbox-label" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "order.servicingActionBreakdownLabel"
                                                )
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              placement: "right",
                                              arrow: true,
                                            },
                                            expression:
                                              "{ placement : 'right',  arrow: true }",
                                          },
                                        ],
                                        staticClass: "info-icon",
                                        attrs: {
                                          content: _vm.$t(
                                            "order.servicingActionBreakdownTooltip"
                                          ),
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "info-icon",
                                          attrs: { src: "/img/info-icon.svg" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "transition",
                                      { attrs: { name: "fade" } },
                                      [
                                        _vm.serviceOperations.includes(
                                          "breakdown"
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "container",
                                                attrs: {
                                                  id: "breakdown-text-container",
                                                },
                                              },
                                              [
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.serviceOperationsBreakdownText,
                                                      expression:
                                                        "serviceOperationsBreakdownText",
                                                    },
                                                  ],
                                                  staticClass: "text-input",
                                                  class: {
                                                    invalid:
                                                      !_vm.validations
                                                        .serviceOperationsBreakdownText
                                                        .is_valid,
                                                  },
                                                  attrs: {
                                                    rows: "2",
                                                    placeholder: _vm.$t(
                                                      "order.servicingActionInputTextPlaceholder"
                                                    ),
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.serviceOperationsBreakdownText,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.serviceOperationsBreakdownText =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          !_vm.validations
                                                            .serviceOperationsBreakdownText
                                                            .is_valid,
                                                        expression:
                                                          "!validations.serviceOperationsBreakdownText.is_valid",
                                                      },
                                                    ],
                                                    staticClass: "validation",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.validations
                                                          .serviceOperationsBreakdownText
                                                          .text
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            this.maintenanceIncluded == true
                              ? _c(
                                  "li",
                                  [
                                    _c("label", { attrs: { for: "other" } }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.serviceOperations,
                                            expression: "serviceOperations",
                                          },
                                        ],
                                        attrs: {
                                          type: "checkbox",
                                          id: "other",
                                          value: "other",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.serviceOperations
                                          )
                                            ? _vm._i(
                                                _vm.serviceOperations,
                                                "other"
                                              ) > -1
                                            : _vm.serviceOperations,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.serviceOperations,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = "other",
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  (_vm.serviceOperations =
                                                    $$a.concat([$$v]))
                                              } else {
                                                $$i > -1 &&
                                                  (_vm.serviceOperations = $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1)))
                                              }
                                            } else {
                                              _vm.serviceOperations = $$c
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "checkbox-label" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "order.servicingActionOtherLabel"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "tippy",
                                            rawName: "v-tippy",
                                            value: {
                                              placement: "right",
                                              arrow: true,
                                            },
                                            expression:
                                              "{ placement : 'right',  arrow: true }",
                                          },
                                        ],
                                        staticClass: "info-icon",
                                        attrs: {
                                          content: _vm.$t(
                                            "order.servicingActionOtherTooltip"
                                          ),
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "info-icon",
                                          attrs: { src: "/img/info-icon.svg" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "transition",
                                      { attrs: { name: "fade" } },
                                      [
                                        _vm.serviceOperations.includes("other")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "container",
                                                attrs: {
                                                  id: "other-text-container",
                                                },
                                              },
                                              [
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.serviceOperationsOtherText,
                                                      expression:
                                                        "serviceOperationsOtherText",
                                                    },
                                                  ],
                                                  staticClass: "text-input",
                                                  class: {
                                                    invalid:
                                                      !_vm.validations
                                                        .serviceOperationsOtherText
                                                        .is_valid,
                                                  },
                                                  attrs: {
                                                    rows: "2",
                                                    placeholder: _vm.$t(
                                                      "order.servicingActionInputTextPlaceholder"
                                                    ),
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.serviceOperationsOtherText,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.serviceOperationsOtherText =
                                                        $event.target.value
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "show",
                                                        rawName: "v-show",
                                                        value:
                                                          !_vm.validations
                                                            .serviceOperationsOtherText
                                                            .is_valid,
                                                        expression:
                                                          "!validations.serviceOperationsOtherText.is_valid",
                                                      },
                                                    ],
                                                    staticClass: "validation",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.validations
                                                          .serviceOperationsOtherText
                                                          .text
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2 &&
          (this.service.pickup_included ||
            this.serviceSlotDefinition.pickup_included ||
            this.service.replacement_car_included ||
            _vm.service.replacement_car_included == false ||
            this.serviceSlotDefinition.replacement_car_included ||
            this.service.car_wash_included ||
            this.serviceSlotDefinition.car_wash_included)
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-12 medium-12 small-12 cell" },
                        [
                          _c("h5", { staticClass: "section-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "order.supplementaryServicesSectionLabel"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            {
                              staticClass: "extended-services-operations-list",
                            },
                            [
                              (this.service.pickup_included == true &&
                                this.slotDefinition == false) ||
                              (this.serviceSlotDefinition.pickup_included ==
                                true &&
                                this.slotDefinition == true)
                                ? _c(
                                    "li",
                                    [
                                      _c(
                                        "label",
                                        { attrs: { for: "pick-up" } },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.extendedServicesOperations,
                                                expression:
                                                  "extendedServicesOperations",
                                              },
                                            ],
                                            attrs: {
                                              type: "checkbox",
                                              id: "pick-up",
                                              value: "pick-up",
                                            },
                                            domProps: {
                                              checked: Array.isArray(
                                                _vm.extendedServicesOperations
                                              )
                                                ? _vm._i(
                                                    _vm.extendedServicesOperations,
                                                    "pick-up"
                                                  ) > -1
                                                : _vm.extendedServicesOperations,
                                            },
                                            on: {
                                              change: [
                                                function ($event) {
                                                  var $$a =
                                                      _vm.extendedServicesOperations,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = "pick-up",
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.extendedServicesOperations =
                                                          $$a.concat([$$v]))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.extendedServicesOperations =
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                    }
                                                  } else {
                                                    _vm.extendedServicesOperations =
                                                      $$c
                                                  }
                                                },
                                                _vm.extendedServicesPickupChanged,
                                              ],
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "checkbox-label" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "order.supplementaryServicesPickUpLabel"
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "transition",
                                        { attrs: { name: "fade" } },
                                        [
                                          _vm.extendedServicesOperations.includes(
                                            "pick-up"
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "container",
                                                  attrs: {
                                                    id: "pick-up-text-container",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "grid-x grid-padding-x",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "large-6 medium-12 small-12 cell",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-label required",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "order.supplementaryServicesPickUpStreetLabel"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.pickupStreet,
                                                                expression:
                                                                  "pickupStreet",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-input",
                                                            attrs: {
                                                              type: "text",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.pickupStreet,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                )
                                                                  return
                                                                _vm.pickupStreet =
                                                                  $event.target.value
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    !_vm
                                                                      .validations
                                                                      .pickupStreet
                                                                      .is_valid,
                                                                  expression:
                                                                    "!validations.pickupStreet.is_valid",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "validation",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .validations
                                                                    .pickupStreet
                                                                    .text
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "large-3 medium-6 small-12 cell",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-label required",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "order.supplementaryServicesPickUpTownLabel"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.pickupTown,
                                                                expression:
                                                                  "pickupTown",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-input",
                                                            attrs: {
                                                              type: "text",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.pickupTown,
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                )
                                                                  return
                                                                _vm.pickupTown =
                                                                  $event.target.value
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    !_vm
                                                                      .validations
                                                                      .pickupTown
                                                                      .is_valid,
                                                                  expression:
                                                                    "!validations.pickupTown.is_valid",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "validation",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .validations
                                                                    .pickupTown
                                                                    .text
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "large-3 medium-6 small-12 cell",
                                                        },
                                                        [
                                                          _c(
                                                            "label",
                                                            {
                                                              staticClass:
                                                                "form-label required",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "order.supplementaryServicesPickUpZipLabel"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.pickupZip,
                                                                expression:
                                                                  "pickupZip",
                                                              },
                                                            ],
                                                            staticClass:
                                                              "form-input",
                                                            attrs: {
                                                              type: "text",
                                                              maxlength: "7",
                                                            },
                                                            domProps: {
                                                              value:
                                                                _vm.pickupZip,
                                                            },
                                                            on: {
                                                              keypress:
                                                                _vm.validNumber,
                                                              input: function (
                                                                $event
                                                              ) {
                                                                if (
                                                                  $event.target
                                                                    .composing
                                                                )
                                                                  return
                                                                _vm.pickupZip =
                                                                  $event.target.value
                                                              },
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    !_vm
                                                                      .validations
                                                                      .pickupZip
                                                                      .is_valid,
                                                                  expression:
                                                                    "!validations.pickupZip.is_valid",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "validation",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .validations
                                                                    .pickupZip
                                                                    .text
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "grid-x grid-padding-x",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "large-12 medium-6 small-12 cell",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              directives: [
                                                                {
                                                                  name: "show",
                                                                  rawName:
                                                                    "v-show",
                                                                  value:
                                                                    !_vm
                                                                      .validations
                                                                      .pickupGeocode
                                                                      .is_valid,
                                                                  expression:
                                                                    "!validations.pickupGeocode.is_valid",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "validation",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .validations
                                                                    .pickupGeocode
                                                                    .text
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (this.service.replacement_car_included == true &&
                                this.slotDefinition == false) ||
                              (this.service.replacement_car_included == false &&
                                this.slotDefinition == false) ||
                              (this.serviceSlotDefinition
                                .replacement_car_included == true &&
                                this.slotDefinition == true)
                                ? _c(
                                    "li",
                                    [
                                      _vm.extendedServicesDeniedReplacementVehicleCodes.includes(
                                        this.replCarEntitlementCode
                                      )
                                        ? _c(
                                            "label",
                                            {
                                              staticStyle: {
                                                color: "#8d8c8c !important",
                                              },
                                              attrs: { for: "replacement-car" },
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.extendedServicesOperations,
                                                    expression:
                                                      "extendedServicesOperations",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id: "replacement-car",
                                                  value: "replacement-car",
                                                  disabled:
                                                    _vm.extendedServicesDeniedReplacementVehicleCodes.includes(
                                                      this
                                                        .replCarEntitlementCode
                                                    )
                                                      ? true
                                                      : false,
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.extendedServicesOperations
                                                  )
                                                    ? _vm._i(
                                                        _vm.extendedServicesOperations,
                                                        "replacement-car"
                                                      ) > -1
                                                    : _vm.extendedServicesOperations,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.extendedServicesOperations,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v =
                                                          "replacement-car",
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.extendedServicesOperations =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.extendedServicesOperations =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.extendedServicesOperations =
                                                        $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "checkbox-label",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "order.supplementaryServicesReplacementCarLabel"
                                                      )
                                                    ) +
                                                      " (" +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "order.supplementaryServicesNotAgreed"
                                                        )
                                                      ) +
                                                      ")"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "label",
                                            {
                                              attrs: { for: "replacement-car" },
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.extendedServicesOperations,
                                                    expression:
                                                      "extendedServicesOperations",
                                                  },
                                                ],
                                                attrs: {
                                                  type: "checkbox",
                                                  id: "replacement-car",
                                                  value: "replacement-car",
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.extendedServicesOperations
                                                  )
                                                    ? _vm._i(
                                                        _vm.extendedServicesOperations,
                                                        "replacement-car"
                                                      ) > -1
                                                    : _vm.extendedServicesOperations,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.extendedServicesOperations,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v =
                                                          "replacement-car",
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          (_vm.extendedServicesOperations =
                                                            $$a.concat([$$v]))
                                                      } else {
                                                        $$i > -1 &&
                                                          (_vm.extendedServicesOperations =
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              ))
                                                      }
                                                    } else {
                                                      _vm.extendedServicesOperations =
                                                        $$c
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "checkbox-label",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "order.supplementaryServicesReplacementCarLabel"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "transition",
                                        { attrs: { name: "fade" } },
                                        [
                                          _vm.extendedServicesOperations.includes(
                                            "replacement-car"
                                          )
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "container",
                                                  attrs: {
                                                    id: "replacement-car-container",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticStyle: {
                                                        "font-weight": "normal",
                                                        "font-size":
                                                          "14px !important",
                                                      },
                                                      attrs: {
                                                        for: "replacement-car-additional",
                                                      },
                                                    },
                                                    [
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm.extendedServicesOperationsReplacementCarAdditional,
                                                            expression:
                                                              "extendedServicesOperationsReplacementCarAdditional",
                                                          },
                                                        ],
                                                        attrs: {
                                                          type: "checkbox",
                                                          id: "replacement-car-additional",
                                                          value:
                                                            "replacement-car-additional",
                                                        },
                                                        domProps: {
                                                          checked:
                                                            Array.isArray(
                                                              _vm.extendedServicesOperationsReplacementCarAdditional
                                                            )
                                                              ? _vm._i(
                                                                  _vm.extendedServicesOperationsReplacementCarAdditional,
                                                                  "replacement-car-additional"
                                                                ) > -1
                                                              : _vm.extendedServicesOperationsReplacementCarAdditional,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            var $$a =
                                                                _vm.extendedServicesOperationsReplacementCarAdditional,
                                                              $$el =
                                                                $event.target,
                                                              $$c = $$el.checked
                                                                ? true
                                                                : false
                                                            if (
                                                              Array.isArray($$a)
                                                            ) {
                                                              var $$v =
                                                                  "replacement-car-additional",
                                                                $$i = _vm._i(
                                                                  $$a,
                                                                  $$v
                                                                )
                                                              if (
                                                                $$el.checked
                                                              ) {
                                                                $$i < 0 &&
                                                                  (_vm.extendedServicesOperationsReplacementCarAdditional =
                                                                    $$a.concat([
                                                                      $$v,
                                                                    ]))
                                                              } else {
                                                                $$i > -1 &&
                                                                  (_vm.extendedServicesOperationsReplacementCarAdditional =
                                                                    $$a
                                                                      .slice(
                                                                        0,
                                                                        $$i
                                                                      )
                                                                      .concat(
                                                                        $$a.slice(
                                                                          $$i +
                                                                            1
                                                                        )
                                                                      ))
                                                              }
                                                            } else {
                                                              _vm.extendedServicesOperationsReplacementCarAdditional =
                                                                $$c
                                                            }
                                                          },
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checkbox-label",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "order.supplementaryServicesReplacementCarAdditional"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2 &&
          this.service.maintenance_slot == true &&
          !this.makeId
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  {
                    staticClass: "large-8 medium-9 small-12 cell centered",
                    staticStyle: { "margin-bottom": "100px" },
                  },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-12 medium-12 small-12 cell" },
                        [
                          _c("h5", { staticClass: "section-title" }, [
                            _vm._v(
                              _vm._s(_vm.$t("order.selectionDateSectionLabel"))
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.selectedSlot.is_valid,
                                  expression:
                                    "!validations.selectedSlot.is_valid",
                                },
                              ],
                              staticClass: "validation",
                              staticStyle: { "text-align": "center" },
                            },
                            [_vm._v(_vm._s(_vm.validations.selectedSlot.text))]
                          ),
                          _vm._v(" "),
                          _c("loader", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.serviceSlotsLoadStatus == 1,
                                expression: "serviceSlotsLoadStatus == 1",
                              },
                            ],
                            attrs: { width: 100, height: 100 },
                          }),
                          _vm._v(" "),
                          _vm.serviceSlotsLoadStatus == 2
                            ? _c("vue-cal", {
                                ref: "vuecal",
                                attrs: {
                                  locale: _vm.$i18n.locale,
                                  "hide-view-selector": "",
                                  "active-view": "week",
                                  "disable-views": [
                                    "years",
                                    "year",
                                    "month",
                                    "day",
                                  ],
                                  time: false,
                                  events: _vm.events,
                                },
                                on: { "event-focus": _vm.onEventFocus },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "title",
                                      fn: function ({ title, view }) {
                                        return [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(title) +
                                              "\n                                "
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "arrow-prev",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.clickedPrevCal()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("i", { staticClass: "angle" }),
                                              _vm._v(" "),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "arrow-next",
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.clickedNextCal()
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("i", { staticClass: "angle" }),
                                              _vm._v(" "),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                    {
                                      key: "weekday-heading",
                                      fn: function ({ heading }) {
                                        return [
                                          _vm._v(
                                            _vm._s(
                                              heading.label.substring(0, 2)
                                            ) +
                                              " " +
                                              _vm._s(
                                                heading.date.format("DD. MM.")
                                              )
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "event",
                                      fn: function ({ event, view }) {
                                        return [
                                          _c("div", {
                                            ref: "slot-" + event.id,
                                            staticClass: "vuecal__event-title",
                                            class: "slot-" + event.id,
                                            attrs: { id: "slot-" + event.id },
                                            domProps: {
                                              innerHTML: _vm._s(event.title),
                                            },
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3791437123
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-12 medium-12 small-12 cell" },
                        [
                          this.selectedEvent.id
                            ? _c(
                                "span",
                                { staticClass: "selected-slot-text" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.$t(
                                          "order.selectionDateSectionSelectedSlotFirst"
                                        )
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.formatDate(this.selectedEvent.start)
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.$t(
                                          "order.selectionDateSectionSelectedSlotSecond"
                                        )
                                      ) +
                                      " " +
                                      _vm._s(_vm.serviceSlotReservationTime) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-12 medium-12 small-12 cell" },
                        [
                          _c("h5", { staticClass: "section-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("order.selectionDateSectionTimeLabel")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.extendedServicesOperations.includes("pick-up")
                            ? _c(
                                "label",
                                {
                                  staticClass: "form-label required",
                                  staticStyle: { "text-align": "center" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "order.selectionDateSectionTimePickUp"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _c(
                                "label",
                                {
                                  staticClass: "form-label required",
                                  staticStyle: { "text-align": "center" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "order.selectionDateSectionTimeBrought"
                                      )
                                    )
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              options: _vm.extendedServicesOperations.includes(
                                "pick-up"
                              )
                                ? _vm.preferredDateTimeOptionsSel
                                : _vm.preferredDateTimeSingleOptionsSel,
                              searchable: false,
                              clearable: false,
                            },
                            model: {
                              value: _vm.slotTime,
                              callback: function ($$v) {
                                _vm.slotTime = $$v
                              },
                              expression: "slotTime",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.validations.slotTime.is_valid,
                                  expression: "!validations.slotTime.is_valid",
                                },
                              ],
                              staticClass: "validation",
                              staticStyle: {
                                "margin-top": "0px",
                                "text-align": "center",
                              },
                            },
                            [_vm._v(_vm._s(_vm.validations.slotTime.text))]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2 &&
          (this.service.maintenance_slot == false ||
            (this.service.maintenance_slot == true && this.makeId))
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _vm.extendedServicesOperations.includes("pick-up")
                      ? _c("h5", { staticClass: "section-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("order.termSectionPickupLabel"))
                          ),
                        ])
                      : _c("h5", { staticClass: "section-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("order.termSectionServiceLabel"))
                          ),
                        ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "section-description" }, [
                      _vm._v(
                        _vm._s(
                          _vm.checkedDateType == "preferred_dates"
                            ? _vm.$t(
                                "order.termSectionPreferredDateDescription"
                              )
                            : _vm.$t("order.termSectionPeriodDescription")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "radio-btn-group" }, [
                      _c("div", { staticClass: "radio" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedDateType,
                              expression: "checkedDateType",
                            },
                          ],
                          attrs: {
                            type: "radio",
                            name: "radio-date-type",
                            value: "preferred_dates",
                            id: "preferred_dates",
                          },
                          domProps: {
                            checked: _vm._q(
                              _vm.checkedDateType,
                              "preferred_dates"
                            ),
                          },
                          on: {
                            change: function ($event) {
                              _vm.checkedDateType = "preferred_dates"
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "preferred_dates" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("order.termSectionPreferredDatesLabel")
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "radio" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkedDateType,
                              expression: "checkedDateType",
                            },
                          ],
                          attrs: {
                            type: "radio",
                            name: "radio-date-type",
                            value: "period",
                            id: "period",
                            checked: "checked",
                          },
                          domProps: {
                            checked: _vm._q(_vm.checkedDateType, "period"),
                          },
                          on: {
                            change: function ($event) {
                              _vm.checkedDateType = "period"
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "period" } }, [
                          _vm._v(
                            _vm._s(_vm.$t("order.termSectionPeriodLabel"))
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.checkedDateType == "preferred_dates"
                      ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                          _c(
                            "div",
                            { staticClass: "large-4 medium-4 small-12 cell" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "form-label required",
                                  staticStyle: { "text-align": "center" },
                                },
                                [
                                  _vm._v(
                                    "1. " +
                                      _vm._s(
                                        _vm.$t(
                                          "order.termSectionPreferredDatesLabel"
                                        )
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-picker", {
                                attrs: {
                                  valueType: "format",
                                  formatter: _vm.momentFormat,
                                  "disabled-date": _vm.disableDatesBeforeToday,
                                  editable: false,
                                  clearable: false,
                                  lang: _vm.$i18n.locale,
                                },
                                model: {
                                  value: _vm.preferredDate1,
                                  callback: function ($$v) {
                                    _vm.preferredDate1 = $$v
                                  },
                                  expression: "preferredDate1",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  options:
                                    _vm.extendedServicesOperations.includes(
                                      "pick-up"
                                    )
                                      ? _vm.preferredDateTimeOptionsSel
                                      : _vm.preferredDateTimeSingleOptionsSel,
                                  searchable: false,
                                  clearable: false,
                                },
                                model: {
                                  value: _vm.preferredDateTime1,
                                  callback: function ($$v) {
                                    _vm.preferredDateTime1 = $$v
                                  },
                                  expression: "preferredDateTime1",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.validations.preferredDate1
                                          .is_valid,
                                      expression:
                                        "!validations.preferredDate1.is_valid",
                                    },
                                  ],
                                  staticClass: "validation",
                                  staticStyle: {
                                    "margin-top": "0px",
                                    "text-align": "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.validations.preferredDate1.text)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "large-4 medium-4 small-12 cell" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "form-label required",
                                  staticStyle: { "text-align": "center" },
                                },
                                [
                                  _vm._v(
                                    "2. " +
                                      _vm._s(
                                        _vm.$t(
                                          "order.termSectionPreferredDatesLabel"
                                        )
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-picker", {
                                attrs: {
                                  valueType: "format",
                                  formatter: _vm.momentFormat,
                                  "disabled-date": _vm.disableDatesBeforeToday,
                                  editable: false,
                                  clearable: false,
                                  lang: _vm.$i18n.locale,
                                },
                                model: {
                                  value: _vm.preferredDate2,
                                  callback: function ($$v) {
                                    _vm.preferredDate2 = $$v
                                  },
                                  expression: "preferredDate2",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  options:
                                    _vm.extendedServicesOperations.includes(
                                      "pick-up"
                                    )
                                      ? _vm.preferredDateTimeOptionsSel
                                      : _vm.preferredDateTimeSingleOptionsSel,
                                  searchable: false,
                                  clearable: false,
                                },
                                model: {
                                  value: _vm.preferredDateTime2,
                                  callback: function ($$v) {
                                    _vm.preferredDateTime2 = $$v
                                  },
                                  expression: "preferredDateTime2",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.validations.preferredDate2
                                          .is_valid,
                                      expression:
                                        "!validations.preferredDate2.is_valid",
                                    },
                                  ],
                                  staticClass: "validation",
                                  staticStyle: {
                                    "margin-top": "0px",
                                    "text-align": "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.validations.preferredDate2.text)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "large-4 medium-4 small-12 cell" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "form-label required",
                                  staticStyle: { "text-align": "center" },
                                },
                                [
                                  _vm._v(
                                    "3. " +
                                      _vm._s(
                                        _vm.$t(
                                          "order.termSectionPreferredDatesLabel"
                                        )
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-picker", {
                                attrs: {
                                  valueType: "format",
                                  formatter: _vm.momentFormat,
                                  "disabled-date": _vm.disableDatesBeforeToday,
                                  editable: false,
                                  clearable: false,
                                  lang: _vm.$i18n.locale,
                                },
                                model: {
                                  value: _vm.preferredDate3,
                                  callback: function ($$v) {
                                    _vm.preferredDate3 = $$v
                                  },
                                  expression: "preferredDate3",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  options:
                                    _vm.extendedServicesOperations.includes(
                                      "pick-up"
                                    )
                                      ? _vm.preferredDateTimeOptionsSel
                                      : _vm.preferredDateTimeSingleOptionsSel,
                                  searchable: false,
                                  clearable: false,
                                },
                                model: {
                                  value: _vm.preferredDateTime3,
                                  callback: function ($$v) {
                                    _vm.preferredDateTime3 = $$v
                                  },
                                  expression: "preferredDateTime3",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.validations.preferredDate3
                                          .is_valid,
                                      expression:
                                        "!validations.preferredDate3.is_valid",
                                    },
                                  ],
                                  staticClass: "validation",
                                  staticStyle: {
                                    "margin-top": "0px",
                                    "text-align": "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.validations.preferredDate3.text)
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkedDateType == "period"
                      ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "large-12 medium-12 small-12 cell preferred-date-period",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "form-label required",
                                  staticStyle: { "text-align": "center" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("order.termSectionPeriodLabel")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("date-picker", {
                                staticStyle: { "text-align": "center" },
                                attrs: {
                                  valueType: "format",
                                  range: "",
                                  "range-separator": " - ",
                                  formatter: _vm.momentFormat,
                                  editable: false,
                                  "disabled-date":
                                    _vm.disableDatesBeforeTodayPeriod,
                                  clearable: false,
                                  lang: _vm.$i18n.locale,
                                },
                                on: { pick: _vm.preferredDatePeriodPick },
                                model: {
                                  value: _vm.preferredDatePeriod,
                                  callback: function ($$v) {
                                    _vm.preferredDatePeriod = $$v
                                  },
                                  expression: "preferredDatePeriod",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.validations.preferredDatePeriod
                                          .is_valid,
                                      expression:
                                        "!validations.preferredDatePeriod.is_valid",
                                    },
                                  ],
                                  staticClass: "validation",
                                  staticStyle: { "text-align": "center" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.validations.preferredDatePeriod.text
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "large-12 medium-12 small-12 cell preferred-date-period",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "form-label required",
                                  staticStyle: { "text-align": "center" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("order.termSectionTimeLabel"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-select", {
                                attrs: {
                                  options:
                                    _vm.extendedServicesOperations.includes(
                                      "pick-up"
                                    )
                                      ? _vm.preferredDateTimeOptionsSel
                                      : _vm.preferredDateTimeSingleOptionsSel,
                                  searchable: false,
                                  clearable: false,
                                },
                                model: {
                                  value: _vm.preferredDatePeriodFrom,
                                  callback: function ($$v) {
                                    _vm.preferredDatePeriodFrom = $$v
                                  },
                                  expression: "preferredDatePeriodFrom",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        !_vm.validations.preferredDatePeriodFrom
                                          .is_valid,
                                      expression:
                                        "!validations.preferredDatePeriodFrom.is_valid",
                                    },
                                  ],
                                  staticClass: "validation",
                                  staticStyle: {
                                    "margin-top": "0px",
                                    "text-align": "center",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.validations.preferredDatePeriodFrom
                                        .text
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.checkedDateType == "preferred_dates" ||
                    _vm.checkedDateType == "period"
                      ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                          _c(
                            "div",
                            { staticClass: "large-12 medium-12 small-12 cell" },
                            [
                              _c("div", { staticClass: "form-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "font-weight-bold d-block",
                                    staticStyle: {
                                      display: "block!important",
                                      "text-align": "center",
                                      "font-weight": "bold",
                                      "margin-bottom": "10px",
                                      "margin-top": "20px",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("order.serviceSupplierLocation")
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "fieldset",
                                  { staticClass: "checkbox-option-wrapper" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-radio checkbox-option-container",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.serviceSupplierLocation,
                                              expression:
                                                "serviceSupplierLocation",
                                            },
                                          ],
                                          staticClass: "checkbox-option-label",
                                          attrs: {
                                            type: "radio",
                                            name: "type",
                                            id: "service-supplier-location-yes",
                                            value: "true",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.serviceSupplierLocation,
                                              "true"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.serviceSupplierLocation =
                                                "true"
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "checkbox-option-label checkbox-option-label-small",
                                            attrs: {
                                              for: "service-supplier-location-yes",
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "checkbox-option-dot",
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("general.yes"))
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-control custom-radio checkbox-option-container",
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.serviceSupplierLocation,
                                              expression:
                                                "serviceSupplierLocation",
                                            },
                                          ],
                                          staticClass: "checkbox-option-label",
                                          attrs: {
                                            type: "radio",
                                            name: "type",
                                            id: "service-supplier-location-no",
                                            value: "false",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.serviceSupplierLocation,
                                              "false"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              _vm.serviceSupplierLocation =
                                                "false"
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "checkbox-option-label checkbox-option-label-small",
                                            attrs: {
                                              for: "service-supplier-location-no",
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "checkbox-option-dot",
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(_vm.$t("general.no"))
                                              ),
                                            ]),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          !_vm.validations
                                            .serviceSupplierLocation.is_valid,
                                        expression:
                                          "!validations.serviceSupplierLocation.is_valid",
                                      },
                                    ],
                                    staticClass: "validation",
                                    staticStyle: {
                                      "margin-top": "5px !important",
                                      "text-align": "center",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.validations.serviceSupplierLocation
                                          .text
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-8 medium-9 small-12 cell centered" },
                  [
                    _c("div", { staticClass: "grid-x grid-padding-x" }, [
                      _c(
                        "div",
                        { staticClass: "large-12 medium-12 small-12 cell" },
                        [
                          _c("span", { staticClass: "bottom-security-text" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("order.securityInfoFirst")) +
                                " "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.$t("order.securityInfoLink"),
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("order.securityInfoSecond"))
                                ),
                              ]
                            ),
                            _vm._v(".\n                                "),
                            _c("br"),
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("order.mandatoryInfoFirst")) +
                                " "
                            ),
                            _c("span", { staticClass: "mandatory" }, [
                              _vm._v("*"),
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("order.mandatoryInfoSecond")) +
                                "\n                            "
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.serviceLoadStatus == 2
            ? _c("div", { staticClass: "grid-x grid-padding-x" }, [
                _c(
                  "div",
                  { staticClass: "large-4 medium-5 small-12 cell centered" },
                  [
                    _c("loader", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.orderFormSentStatus == 1,
                          expression: "orderFormSentStatus == 1",
                        },
                      ],
                      attrs: { width: 100, height: 100 },
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.orderFormSentStatus != 1,
                            expression: "orderFormSentStatus != 1",
                          },
                        ],
                        staticClass: "order-button",
                        on: {
                          click: function ($event) {
                            return _vm.submitOrderService()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("order.submitFormButton")))]
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }